import { NavLink } from 'react-router-dom'
import type { ReactNode } from 'react'

const links = [
  { to: '/', label: 'Painel', icon: '📊' },
  { to: '/quadro', label: 'Quadro', icon: '📋' },
  { to: '/decisoes', label: 'Decisoes', icon: '⚖️' },
  { to: '/pesquisas', label: 'Pesquisas', icon: '🔍' },
  { to: '/roadmap', label: 'Roadmap', icon: '🗺️' },
]

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <aside className="w-56 bg-prorural-dark text-white flex flex-col shrink-0">
        <div className="p-4 border-b border-blue-800">
          <h1 className="text-lg font-bold">Prorural</h1>
          <p className="text-blue-300 text-sm">Expansao Digital</p>
        </div>
        <nav className="flex-1 py-2">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/'}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 text-sm transition-colors ${
                  isActive
                    ? 'bg-blue-700/50 text-white font-medium'
                    : 'text-blue-200 hover:bg-blue-800/50 hover:text-white'
                }`
              }
            >
              <span className="text-base">{l.icon}</span>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-blue-800 text-xs text-blue-400">
          <a href="/" className="hover:text-white">← Portal</a>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto bg-gray-50">
        {children}
      </main>
    </div>
  )
}
